import React from 'react'
import StyledDiv from './styles'
import { Button, Modal, PaymentGatewayRedirectOverlay } from '../../../components'
import { IPaymentState } from '../../../models'
import { LiteralsService } from '../../../services'

interface IProps {
  visible: boolean
  paymentState: IPaymentState
  isRefund: boolean
  isRedirectingToPaymentGateway?: boolean
  close: () => void
  confirmPayment: () => void
}

export const ConfirmPaymentModal: React.FC<IProps> = ({
  visible,
  paymentState,
  isRefund,
  isRedirectingToPaymentGateway,
  close,
  confirmPayment
}) => {

  const modalContent = () => {
    return (
      <StyledDiv>
        <header>
          <h3> { LiteralsService.get( isRefund ? 'confirmRefundTitle' : 'confirmPaymentTitle', true ) } </h3>
        </header>
        <section>
            <Button 
              title={ LiteralsService.get('confirm', true) }
              onPress={ confirmPayment }
              isDisabled={ isRedirectingToPaymentGateway || paymentState === IPaymentState.DOING_PAYMENT }
              filled
              upper
            />
            <Button 
              title={ LiteralsService.get('cancel', true) }
              onPress={ close }
              isDisabled={ isRedirectingToPaymentGateway || paymentState === IPaymentState.DOING_PAYMENT }
              upper
            />
        </section>
        { isRedirectingToPaymentGateway && <PaymentGatewayRedirectOverlay /> }
      </StyledDiv>
    )
  }

  if (!visible) return null
  return (
    <Modal className='small' onOverlayClick={ isRedirectingToPaymentGateway ? undefined : close }>
      { modalContent() }
    </Modal>
  )

}